var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleMusicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9075 5H18.0925C10.8617 5 5 11.0768 5 18.5729V96.4271C5 103.923 10.8617 110 18.0925 110H96.9075C104.139 110 110 103.923 110 96.4271V18.5729C110 11.0768 104.139 5 96.9075 5Z",
    fill: "#FFCCFF",
    stroke: "#0F2A3D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.793 16.4854C86.2265 16.2156 87.7051 16.5921 88.8281 17.5244H88.8271C89.9547 18.4555 90.5995 19.8274 90.5996 21.2832V74.8018H90.5781C90.2288 82.7064 83.6684 89.0283 75.6523 89.0283H74.2178C71.2168 89.0283 68.3406 87.7576 66.3242 85.541V85.54C64.3097 83.3249 63.3281 80.3365 63.626 77.3486V77.3477C64.1703 71.9798 69.0191 67.8281 74.6279 67.8281H78.5215C81.3576 67.8281 83.6611 65.5306 83.6611 62.7129V35.4482L50.4268 41.6533V82.7139C50.4268 90.925 43.7188 97.5996 35.4785 97.5996H34.0439C31.0431 97.5996 28.1677 96.3287 26.1514 94.1123C24.1366 91.8971 23.1542 88.908 23.4521 85.9199V85.9189C23.9965 80.5513 28.8454 76.3996 34.4541 76.3994H38.3486C41.1846 76.3993 43.4872 74.1027 43.4873 71.2852V29.4355C43.4873 26.3937 45.6662 23.7842 48.6631 23.2285L84.793 16.4863V16.4854Z",
    fill: "#FF3F7B",
    stroke: "#0F2A3D",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusicIcon);
export default __webpack_public_path__ + "static/media/apple-music-icon.7649a5c6.svg";
export { ForwardRef as ReactComponent };